export default __webpack_public_path__ + "static/media/section2b-grid9img.a4e54f10.svg";